<template>
    <!-- <b-modal size="lg" id="modalRegistrarAfericao" v-model="registraAfericao" data-backdrop="static"
        data-keyboard="false" centered :title="'NR Fogo: ' + pneu"> -->
    <div id="registraAfericao">
        <div class="container mb-3">
            <div class="col-12 d-flex justify-content-center">
                <p>{{ $t('Aferindo NR Fogo') }}:
                    <span class="badge badge-warning" style="font-size:16px">{{
                        pneu
                        }}</span>
                </p>

            </div>
            
            <div class="pl-5 pb-4 pt-2 col-auto d-flex align-items-center justify-content-center">
                <input type="checkbox" id="inverter" v-model="inverterPneu" class="form-check-input me-2" 
                        style="font-size: 20px; margin-right: 7rem; margin-bottom: 5px;" />
                <label for="inverter" class="form-check-label mb-0">{{ $t('Inverter pneus') }}</label>
            </div>
            
            <div class="col-12 d-flex justify-content-center">
                <span class="col-5">{{ $t('Última Aferição') }}:</span>
                <span class="col-5">{{ $t('Novas Aferições') }}:</span>
            </div>


            <div class="col-12 d-flex justify-content-center" v-for="(mm, index) in afericoesFeitasTemp" :key="index">
                <input disabled class="col-5 form-control m-1" type="number" :value="mm.valor">
                <input class="col-5 form-control m-1" type="number" :value="mm.valueTemp"
                    @change="inputAfericao(mm, $event)">
            </div>
        </div>
        <div class="w-100">
            <div class="row center mb-3" style="justify-content: center;">
                <!-- <b-button class="mr-2" variant="danger" size="lg" @click="$emit('closeModal')">
                    {{ $t('Cancelar') }}
                </b-button> -->
                <b-button size="lg" variant="success" @click="registrarAfericao">
                    {{ $t('Confirmar') }}
                </b-button>
            </div>
        </div>
    </div>
    <!-- </template> -->
    <!-- </b-modal> -->
</template>
<script>

export default {
    name: "ModalExterna",
    props: {
        afericoesFeitas: {},
        pneu: {}
    },

    data() {
        return {
            arrayAfericoes: [],
            registraAfericao: true,
            afericoesFeitasTemp: [],
            photo: null,
            mediaStream: null,
            inverterPneu: false
        };
    },
    methods: {

        registrarAfericao() {
            let pneus = this.$store.getters['borracharia/getAfericao']

            if (this.arrayAfericoes.length < this.afericoesFeitasTemp.length) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Informe a leitura de todos os sulcos', 
                    icon: 'warning'
                })

                return false
            }

            let ds_lado = ''
            let nr_posicao = ''
            let nr_vida = ''
            let idpneu = ''
 
            pneus.forEach(item => {
                console.log('Este é o pneu')
                console.log(item)
                if (item.nr_fogo.replace(/\s+/g, '') == this.pneu.replace(/\s+/g, '')) {
                    ds_lado = item.ds_lado
                    nr_posicao = item.nr_posicao
                    nr_vida = item.nr_vida
                    idpneu = item.idpneu

                    console.log(ds_lado)
                    console.log(item.ds_lado)
                }
            })

            const dataAfericao = {
                nr_fogo: this.pneu,
                ds_lado: ds_lado,
                nr_posicao: nr_posicao,
                afericoes: this.arrayAfericoes,
                imagem: this.photo,
                nr_vida: nr_vida,
                idpneu: idpneu,
                inverterPneu: this.inverterPneu
            }

            // console.log(dataAfericao)
            this.$emit('adicionarAfericao', dataAfericao)
        },

        inputAfericao(mm, event) {
            if (Number(event.target.value) > Number(mm.valor)) {
                this.$swal.fire({
                    title: 'Oops!',
                    text: 'Informe uma aferição menor que a atual!',
                    icon: 'warning'
                })

                event.target.value = ''
                return false
            }

            let data = {
                index: mm.indice,
                ultimaAfericao: mm.valor,
                novaAfericao: event.target.value
            }

            var indice = this.arrayAfericoes.findIndex(function (item) {
                return item.index === data.index;
            });

            if (indice !== -1) {
                this.arrayAfericoes[indice] = data;
            } else {
                this.arrayAfericoes.push(data);
            }
        },

        verificaAfericoesFeitas() {
            // const afericoes = JSON.parse(localStorage.afericao)

            // afericoes.forEach(afer => { 
            //     console.log(afer)
            //     console.log(this.pneu)
            //     // if(afer.nr_fogo == this.pneu){
            //     //     this.afericoesFeitasTemp = afer.afericoes
            //     // }
            // })
        },

        populaArray() {
            this.afericoesFeitasTemp = JSON.parse(JSON.stringify(this.afericoesFeitas));
            // const aferTemp = JSON.parse(localStorage.afericao)

            // const self = this

            // aferTemp.afericoes.forEach(afericaoTemp => {

            //     if (afericaoTemp.nr_fogo == self.pneu) {
            //         afericaoTemp.afericoes.forEach(function (afer, index) {
            //             self.afericoesFeitasTemp[index].valueTemp = afer.novaAfericao
            //         })
            //     }
            // })
        }
    },

}
</script>
